import { TruncateWordsPipe } from './shared/pipes/truncate-word.pipe';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { ResizableModule } from 'angular-resizable-element';

import { OverviewPanelComponent } from './modules/overview-panel/overview-panel.component';
import { MainPanelComponent } from './modules/main-panel/main-panel.component';
import { SignupComponent } from './modules/signup/signup.component';
import { LoginComponent } from './modules/login/login.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import 'd3';
import { SHARED_VISUALS } from './visuals/shared';
import { D3Service, D3_DIRECTIVES } from './d3';
import { SearchSectionComponent } from './modules/search-section/search-section.component';
import { MultiDocSummarySectionComponent } from './modules/multi-doc-summary-section/multi-doc-summary-section.component';
import { ArticlesSectionComponent } from './modules/articles-section/articles-section.component';
import { ArticleComponent } from './modules/article/article.component';
import { ArticleLongStoryComponent } from './modules/article-long-story/article-long-story.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { DashboardHomeComponent } from './modules/dashboard-home/dashboard-home.component';
import { ToastrModule } from 'ngx-toastr';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { loginRequest, msalConfig } from '../app/config/auth-config';
import { IPublicClientApplication, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalModule, MsalRedirectComponent, MsalService } from '@azure/msal-angular';
import { MsalHttpInterceptor } from './core/http/MsalHttpInterceptor';
import { HttpErrorInterceptor } from './core/http/error-handler';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgxTypedJsModule } from 'ngx-typed-js';
import { APP_CONFIG, APP_DI_CONFIG } from './configs/app-config.constants';
import { OverlayModule } from '@angular/cdk/overlay';
import { ClickOutsideDirective } from './directives/clickoutside.directive';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { TruncatePipe } from './shared/pipes/truncate.pipe';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { PopoverModule } from 'ngx-bootstrap/popover';

export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication(msalConfig);
}
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: loginRequest,
    };
}
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ArticleNetworkGraphComponent } from './modules/article-network-graph/article-network-graph.component';
import { GraphComponent } from './visuals/graph/graph.component';
import { VerificationComponent } from './modules/verification/verification.component';
import { LeftPopoverComponent } from './modules/left-popover/left-popover.component';
import { GetproComponent } from './modules/getpro/getpro.component';
import { ClickPopoverDirective } from './click-popover.directive';
// D3 js module
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SubmitGyanComponent } from './modules/submit-gyan/submit-gyan.component';
// import { NgxBootstrapSliderModule } from 'ngx-bootstrap-slider';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { GyanInputComponent } from './modules/gyan-input/gyan-input.component';
import { TopicFormComponent } from './modules/topic-form/topic-form.component';
import { KeyConceptComponent } from './modules/key-concept/key-concept.component';
import { GyanTemplatesComponent } from './modules/gyan-templates/gyan-templates.component';
import { MyKnowledgeStoreComponent } from './modules/my-knowledge-store/my-knowledge-store.component';
import { GyanKnowledgeStoreComponent } from './modules/gyan-knowledge-store/gyan-knowledge-store.component';
import { GyanOrganisationComponent } from './modules/gyan-organisation/gyan-organisation.component';
import { TopicOutlineComponent } from './modules/gyan-organisation/topic-outline/topic-outline.component';
import { ToggleDropdownComponent } from './modules/gyan-organisation/toggle-dropdown/toggle-dropdown.component';
import { ToggleButtonComponent } from './modules/gyan-organisation/toggle-button/toggle-button.component';
import { BreadcrumbComponent } from './modules/gyan-organisation/breadcrumb/breadcrumb.component';
import { FolderListComponent } from './modules/gyan-organisation/folder-list/folder-list.component';
import { MoveBreadcrumbComponent } from './modules/gyan-organisation/moveBreadcrumb/moveBreadcrumb.component';
import { SubTopicSourcesComponent } from './modules/sub-topic-sources/sub-topic-sources.component';
import { TocSettingsComponent } from './modules/toc-settings/toc-settings.component';
import { DraftListComponent } from './modules/draft-list/draft-list.component';
// import { AdminComponent } from './admin/admin.component';
import { AdminComponent } from './modules/admin/admin.component';
import { AdminDashboardComponent } from './modules/admin-dashboard/admin-dashboard.component';
import { ClientsComponent } from './modules/clients/clients.component';
import { ClientService } from './modules/clients/clients.service';
import { UserComponent } from './modules/user/user.component';
import { AdminUsergroupComponent } from './modules/admin-usergroup/admin-usergroup.component';
import { UserService } from './modules/user/user.service';
import { MultiSelectDropdownComponent } from './shared/controls/multi-select-dropdown/multi-select-dropdown.component';
import { MKSComponent } from './modules/admin-mks/admin-mks.component';
import { AdminGksComponent } from './modules/admin-gks/admin-gks.component';
import { AdminAccessComponent } from './modules/admin/admin-access/admin-access.component';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        AppComponent,
        DashboardComponent,
        OverviewPanelComponent,
        MainPanelComponent,
        SignupComponent,
        LoginComponent,
        SearchSectionComponent,
        MultiDocSummarySectionComponent,
        ArticlesSectionComponent,
        ArticleComponent,
        DashboardHomeComponent,
        ArticleLongStoryComponent,
        ArticleNetworkGraphComponent,
        MultiSelectDropdownComponent,
        GraphComponent,
        ...SHARED_VISUALS,
        ...D3_DIRECTIVES,
        VerificationComponent,
        LeftPopoverComponent,
        GetproComponent,
        ClickPopoverDirective,
        ClickOutsideDirective,
        SubmitGyanComponent,
        GyanOrganisationComponent,
        TopicOutlineComponent,
        TruncatePipe,
        TruncateWordsPipe,
        GyanInputComponent,
        TopicFormComponent,
        KeyConceptComponent,
        GyanTemplatesComponent,
        ToggleDropdownComponent,
        ToggleButtonComponent,
        BreadcrumbComponent,
        FolderListComponent,
        MoveBreadcrumbComponent,
        MyKnowledgeStoreComponent,
        GyanKnowledgeStoreComponent,
        SubTopicSourcesComponent,
        TocSettingsComponent,
        DraftListComponent,
        AdminComponent,
        AdminDashboardComponent,
        ClientsComponent,
        UserComponent,
        AdminUsergroupComponent,
        MKSComponent,
        AdminGksComponent,
        AdminAccessComponent,
    ],
    imports: [
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        FontAwesomeModule,
        CarouselModule,
        FormsModule,
        MsalModule,
        HttpClientModule,
        ReactiveFormsModule,
        NgScrollbarModule,
        ResizableModule,
        NgxTypedJsModule,
        AccordionModule,
        PaginationModule,
        PopoverModule.forRoot(),
        // NgxBootstrapSliderModule,
        NgxSliderModule,
        NgSelectModule,
        InfiniteScrollModule,
        ToastrModule.forRoot(),
        BsDropdownModule.forRoot(),

        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalHttpInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true,
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory,
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory,
        },
        {
            provide: APP_CONFIG,
            useValue: APP_DI_CONFIG,
        },
        MsalService,
        MsalGuard,
        D3Service,
        MsalBroadcastService,
        ClientService,
        UserService,
    ],
    bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}
